import { render, staticRenderFns } from "./ParagraphWithHeadings.vue?vue&type=template&id=f324ca72&scoped=true&"
import script from "./ParagraphWithHeadings.vue?vue&type=script&lang=ts&"
export * from "./ParagraphWithHeadings.vue?vue&type=script&lang=ts&"
import style0 from "./ParagraphWithHeadings.vue?vue&type=style&index=0&id=f324ca72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../home/bearlogin/development/pinq-project/mono2/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f324ca72",
  null
  
)

export default component.exports